(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac-projects-home"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('click',function(event){const open=event.target.closest('[data-ac-project-open]');if(open){const dialog=document.getElementById(open.dataset.acProjectOpen);if(dialog&&!dialog.open)dialog.showModal();return;}const close=event.target.closest('[data-ac-project-close]');if(close){close.closest('dialog').close();return;}const target=event.target;if(target instanceof HTMLDialogElement&&target.classList.contains('ac-projects__dialog')){const rect=target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)target.close();}});


  } catch(e) { console.error(e); }
})();
})();
